export type HttpError = {
	data: {
		status: number;
		title: string;
	};
};

export const getHttpErrorTitle = (error: unknown): string | null => {
	const { data } = (error ?? {}) as Partial<HttpError>;

	return data?.title ?? null;
};
